<template>
	<div class="info-create">
		<el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
			<el-form-item label="商场" prop="mkId" required>
				<el-select v-model="form.mkId" placeholder="请选择商场" :disabled="form.id" filterable @change="onMkChange">
					<el-option v-for="(item, index) in mallOption" :label="item.name" :value="item.id"
						:key="index"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="店铺" prop="storeId" required v-if="form.mkId">
				<el-cascader :props="props" v-model="form.storeId" :options="floors"></el-cascader>
				<!-- <el-select v-model="form.storeId" placeholder="请选择店铺" :disabled="form.id" filterable
					:loading="spLoading">
					<el-option v-for="(item, index) in shopOption" :label="item.name" :value="item.id"
						:key="index"></el-option>
				</el-select> -->
			</el-form-item>
			<el-form-item v-if="form.randomNumber" label="数量" prop="randomNumber" required>
				<el-input-number v-model="form.randomNumber" placeholder="请输入数量" class="input" />
			</el-form-item>
			<!-- <el-form-item v-if="form.storeId" label="账户名" prop="name" required>
				<el-input v-model="form.name" placeholder="请输入账户名" class="input" :disabled="form.id" />
			</el-form-item>
			<el-form-item v-if="form.storeId" label="密码" prop="passWord" required>
				<el-input v-model="form.passWord" placeholder="请输入密码" class="input" show-password />
			</el-form-item> -->
			<div class="footer">
				<el-button @click="onBack" class="fun-btn mr20">取消</el-button>
				<el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import {
		getMarkets,
		add,
		update,
		getShops
	} from "@/api/writeoffAccount";
	import {
		api_getConfig
	} from '@/api/common'
	var _this = null;
	export default {
		name: "writeoffAccount",
		components: {},
		data() {
			return {
				floors: [{
						value: 'B2',
						label: `B2`,
						leaf: false,
					},
					{
						value: 'B1',
						label: `B1`,
						leaf: false,
					},
					{
						value: '1F',
						label: `1F`,
						leaf: false,
					},
					{
						value: '2F',
						label: `2F`,
						leaf: false,
					},
					{
						value: '3F',
						label: `3F`,
						leaf: false,
					},
					{
						value: '4F',
						label: `4F`,
						leaf: false,
					},
					{
						value: '5F',
						label: `5F`,
						leaf: false,
					},
				],
				props: {
					lazy: true,
					multiple: false,
					lazyLoad(node, resolve) {
						console.log('当前节点：', this, node)
						if (node.level == 0) {
							resolve(floors);
						}
						_this.selQuery.mallIds = [_this.form.mkId];
						_this.selQuery.floor = node.value;
						let nodes = [];
						getShops(_this.selQuery).then(res => {
							if (res.list) {
								res.list.forEach(i => {

									//if (i.disable != true) {
										nodes.push({
											value: i.id,
											label: i.name,
											leaf: true,
										})
									//}
								})
							}
							resolve(nodes);
						})
					},
				},
				spLoading: false,
				shopOption: [],
				form: {
					id: undefined,
					mkId: '',
					storeId: '',
					/* passWord: '',
					name: '', */
					randomNumber:1
				},
				selQuery: {
					mallIds: [],
					disable:false,
					name: '',
					floor: '',
					offset: 0,
					limit: 100
				},
				mallOption: [],
				rules: {
					mkId: [{
						required: true,
						message: "请选择商场"
					}],
					storeId: [{
						required: true,
						message: "请选择店铺"
					}],
					randomNumber: [{
						required: true,
						message: "请输入数量"
					}],
					/* name: [{
						required: true,
						message: '请输入账户名'
					}],
					passWord: [{
						required: true,
						message: "请输入密码"
					}] */
				},
				submitLoading: false
			};
		},
		created() {
			_this = this;
			if (this.$route.query.id) {
				this.$route.meta.breadcrumbTitle =
					'<span class="noblack">服务配置/核销账户<span class="black">/编辑信息</span></span>';
				this.getInfo();
			} else {
				this.$route.meta.breadcrumbTitle =
					'<span class="noblack">服务配置/核销账户<span class="black">/创建信息</span></span>';
			}
			this.getConfigData();
			this.getDetail();
		},
		methods: {

			onMkChange(e) {
				this.form.storeId = '';
				this.floors = [];
				this.floors = [{
						value: 'B2',
						label: `B2`,
						leaf: false,
					},
					{
						value: 'B1',
						label: `B1`,
						leaf: false,
					},
					{
						value: '1F',
						label: `1F`,
						leaf: false,
					},
					{
						value: '2F',
						label: `2F`,
						leaf: false,
					},
					{
						value: '3F',
						label: `3F`,
						leaf: false,
					},
					{
						value: '4F',
						label: `4F`,
						leaf: false,
					},
					{
						value: '5F',
						label: `5F`,
						leaf: false,
					},
				];
				console.log('当前floor', this.floors)
				//this.shopOption = [];
				//this.spLoading = true;
				//this.getCurrShops(this.form.mkId)
			},

			// 获取config数据（商场、店铺级联框）
			async getConfigData() {
				let {
					mall
				} = await api_getConfig(['mall'])
				this.mallOption = mall
			},

			// 获取 店铺
			async getCurrShops(mkId) {
				this.selQuery.mallIds = [mkId]

				console.log('当前选中', mkId)
				let shops = await getShops(this.selQuery);
				console.log('当前返回值：', _.list)
				this.spLoading = false;
				this.shopOption = _.list

				return this.shopOption;
			},
			// 获取详情
			async getDetail() {
				/* let { mall } = await api_getConfig(["mall"]);
				mall.forEach(item => item.id = item.id + '')
				this.mallOption = mall; */
			},

			// 商场下拉框改变
			onMallChange(data) {
				if (data.indexOf('ALL') >= 0) {
					this.form.selectedRange = ['ALL']
				}
			},

			// 点击提交按钮
			onSubmit() {

				this.$refs.form.validate(async valid => {
					if (valid) {
						this.submitLoading = true;
						if (this.form.storeId) {
							this.form.storeId = this.form.storeId[1]
						}
						try {
							let result = this.$route.query.id ?
								await update(this.form) :
								await add(this.form);
								
								console.log('当前结果：',result)
							
							this.$baseMessage("操作成功", "success");
							this.onBack();
						} catch (ex) {
							//this.$baseMessage("操作失败！"+ex.message, "error");
						}
						this.submitLoading = false;
					}
				});
			},
			typeChange() {
				this.form.storeId = ''
				this.form.name = ''
				this.form.passWord = ''
				this.$refs.form.clearValidate();
			},
			// 字符串截取
			sliceString(str, prefix) {
				if (str.indexOf(prefix) === 0) {
					return str.slice(prefix.length);
				}
				return str;
			},

			// 返回
			onBack() {
				this.$router.back(-1);
			}
		}
	};
</script>

<style>
	.el-input-number{
		line-height: 30px !important;
	}
</style>

<style lang="scss" scoped>
	.info-create {
		width: 100%;
		padding-top: 20px;
		box-sizing: border-box;
		position: relative;
		padding-bottom: 100px;

		.el-input,
		.el-textarea,
		.el-select {
			width: 350px;
		}

		.input-remark {
			height: 17px;
			line-height: 17px;
			font-size: 12px;
			color: #999999;
			position: absolute;
			left: 350px;
			bottom: 0;
		}

		.optional {
			height: 17px;
			line-height: 17px;
			margin-top: 5px;
			font-size: 12px;
			color: #666666;
		}

		::v-deep {
			.avatar-uploader {
				height: 152px;
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			padding: 20px 0;
			padding-left: 70px;
			background: #fff;
			width: calc(100vw - #{$base-left-menu-width});
			left: $base-left-menu-width;
		}
	}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>